// app-events — tiny window-event bus for cross-screen refreshes.
//
// Used so the Admin badge in AppShell (pending-approval count) updates
// the moment UsersTab approves / deletes / preseeds a user, instead of
// waiting for the next route change. A DOM event keeps AppShell and the
// admin tabs decoupled (no prop threading through AdminPanel).

const USERS_CHANGED = 'nayto:users-changed';

export function emitUsersChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(USERS_CHANGED));
}

/** Subscribe; returns the unsubscribe function (for useEffect cleanup). */
export function onUsersChanged(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(USERS_CHANGED, cb);
  return () => window.removeEventListener(USERS_CHANGED, cb);
}
